"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_POINT = exports.ROOT = void 0;
exports.ROOT = 'floating-container';
exports.BASE_POINT = {
    TOP_LEFT: 'top-left',
    TOP_MID: 'top-mid',
    TOP_RIGHT: 'top-right',
    LEFT_MID: 'left-mid',
    RIGHT_MID: 'right-mid',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_MID: 'bottom-mid',
    BOTTOM_RIGHT: 'bottom-right'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLElBQUksR0FBRyxvQkFBb0IsQ0FBQztBQUU1QixRQUFBLFVBQVUsR0FBRztJQUN0QixRQUFRLEVBQUUsVUFBVTtJQUNwQixPQUFPLEVBQUUsU0FBUztJQUNsQixTQUFTLEVBQUUsV0FBVztJQUN0QixRQUFRLEVBQUUsVUFBVTtJQUNwQixTQUFTLEVBQUUsV0FBVztJQUN0QixXQUFXLEVBQUUsYUFBYTtJQUMxQixVQUFVLEVBQUUsWUFBWTtJQUN4QixZQUFZLEVBQUUsY0FBYztDQUMvQixDQUFDIn0=